import React from 'react'
import { Row, Col } from 'react-bootstrap'

export default function OrderFilterStatus({ workingStatus, onClick, onClickCreate, action }) {
  return (
    <Row>
      <Col>
        <div className="d-flex justify-content-between">
          <div className="d-flex pb-2">
            <div className="btn-group">
              <div
                className={workingStatus === 'PENDING' ? 'btn btn-info' : 'btn btn-outline-info'}
                onClick={() => onClick({ color: 'bg-info', message: 'รอแจ้งโอน', status: 'PENDING' })}
              >
                รอแจ้งโอน
              </div>
              <div
                className={
                  workingStatus === 'CONFIRMED' && action === 'NONE' ? 'btn btn-warning' : 'btn btn-outline-warning'
                }
                onClick={() =>
                  onClick({ color: 'bg-warning', message: 'แจ้งโอนแล้ว', status: 'CONFIRMED', action: 'NONE' })
                }
              >
                แจ้งโอนแล้ว{' '}
              </div>
              <div
                className={workingStatus === 'SUCCESS' ? 'btn btn-success' : 'btn btn-outline-success'}
                onClick={() => onClick({ color: 'bg-success', message: 'ซื้อสำเร็จ', status: 'SUCCESS' })}
              >
                ซื้อสำเร็จ{' '}
              </div>
              <div
                className={workingStatus === 'CANCEL' ? 'btn btn-danger' : 'btn btn-outline-danger'}
                onClick={() => onClick({ color: 'bg-danger', message: 'ยกเลิก', status: 'CANCEL' })}
              >
                ยกเลิก
              </div>
            </div>
            <div className="pl-4 btn-group">
              <div
                className={
                  action === 'IN_PROGRESS' && workingStatus === 'CONFIRMED'
                    ? 'btn btn-secondary'
                    : 'btn btn-outline-secondary'
                }
                onClick={() =>
                  onClick({ color: 'bg-secondary', message: 'ล็อค', status: 'CONFIRMED', action: 'IN_PROGRESS' })
                }
              >
                ล็อค
              </div>
              <div
                className={
                  action === 'BLOCKED' && workingStatus === 'CONFIRMED' ? 'btn btn-dark' : 'btn btn-outline-dark'
                }
                onClick={() =>
                  onClick({ color: 'bg-dark', message: 'มีปัญหา', status: 'CONFIRMED', action: 'BLOCKED' })
                }
              >
                มีปัญหา{' '}
              </div>
              <div className={workingStatus === 'SEARCH' ? 'btn btn-primary' : 'btn btn-outline-primary'}>ค้นหา</div>
            </div>
          </div>
          <div>
            <div className="btn btn-primary" onClick={onClickCreate}>
              เพิ่มคำสั่งซื้อ
            </div>
          </div>
        </div>
      </Col>
    </Row>
  )
}
